import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import config from '@/lib/config/index';
import {
  ElearningTag,
  FaqTag,
  FramesTag,
  HelperTag,
  MyElearningTag,
  CourseLibraryTag,
  VideoLibraryTag,
  VocamRegionsTag,
  VocamChannelsTag,
  VideoPreviewLinkTag,
  VideoLinkTag,
  CourseLibraryDownloadResultTag,
  MyElearningDetailsTag,
  ResourcesTag,
  TemplatesTag,
  TemplateTag,
  ThemesTag,
  ThemeTag,
  ThemeDefaultTag,
  QuizzesTag,
  QuizAttemptTag,
  QuestionsTag,
  QuestionTag,
  AuthTag,
  UserInfoTag,
  SignedCookieTag,
  AdminSignedCookieTag,
  ManifestTag,
  ElementTag,
  ChoicesTag,
  ReviewersTag,
  ReviewerTag,
  FrameCommentsTag,
  ReviewerCommentsTag,
  ReviewerElearningCommentsTag,
  CommentsTag,
  ElearningPulishReviewResult,
  TenantTag,
  TenantsTag,
  TenantProfileTag,
  NavigationsTag,
  ElearningCategoriesListTag,
  ElearningCategoryTag,
  ElearningCategoriesAllowedListTag,
  ScormCookieTag,
  TenantCategoriesTag,
  ScormVocamVideoLinkTag,
  BreatheVocamVideoLinkTag,
} from './tags';
import fetchBaseQueryWrapper from './fetchBaseQueryWrapper';

const API_PREFIX = config.api.enableBFF ? '/api' : '';
const VERSION = 'v1';
const BASE_URL = `${config.api.baseUrl}${API_PREFIX}/${VERSION}/`;

let tenantIdentifier: string = window.location.host.split('.')[0];
if (tenantIdentifier === undefined || process.env.NODE_ENV === 'development') {
  // force to 1cover easy for local development
  tenantIdentifier = '1cover';
}

export const TENANT_IDENTIFIER: string = tenantIdentifier;

// File upload base query that doesn't set Content-Type (for FormData)
export const fileUploadBaseQuery = fetchBaseQuery({
  baseUrl: BASE_URL,
  prepareHeaders: (headers) => {
    // Don't set Content-Type - let browser handle FormData multipart encoding
    headers.set('tenant-identifier', tenantIdentifier);
    headers.set('namespace', 'elmoau');
    headers.set('authorization', config.api.authorization);
    headers.set('X-Requested-With', 'XMLHttpRequest');
    return headers;
  },
});

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQueryWrapper({
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      headers.set('Content-Type', 'application/json');
      headers.set('tenant-identifier', tenantIdentifier);
      headers.set('namespace', 'elmoau');
      headers.set('authorization', config.api.authorization);
      headers.set('X-Requested-With', 'XMLHttpRequest');

      return headers;
    },
  }),
  tagTypes: [
    MyElearningTag,
    CourseLibraryTag,
    VideoLibraryTag,
    VocamRegionsTag,
    VocamChannelsTag,
    VideoPreviewLinkTag,
    VideoLinkTag,
    CourseLibraryDownloadResultTag,
    MyElearningDetailsTag,
    ElearningTag,
    ResourcesTag,
    HelperTag,
    FaqTag,
    FramesTag,
    TemplatesTag,
    TemplateTag,
    ThemesTag,
    ThemeTag,
    ThemeDefaultTag,
    QuizzesTag,
    QuizAttemptTag,
    QuestionsTag,
    QuestionTag,
    AuthTag,
    UserInfoTag,
    TenantTag,
    TenantsTag,
    TenantProfileTag,
    TenantCategoriesTag,
    SignedCookieTag,
    AdminSignedCookieTag,
    ManifestTag,
    ElementTag,
    ChoicesTag,
    ReviewersTag,
    ReviewerTag,
    CommentsTag,
    FrameCommentsTag,
    ReviewerCommentsTag,
    ReviewerElearningCommentsTag,
    ElearningPulishReviewResult,
    NavigationsTag,
    ElearningCategoriesListTag,
    ElearningCategoryTag,
    ElearningCategoriesAllowedListTag,
    ScormCookieTag,
    ScormVocamVideoLinkTag,
    BreatheVocamVideoLinkTag,
  ],
  endpoints: () => ({}),
});

export default baseApi;
